module.exports = __webpack_public_path__ + "img/minsheng.50e3b425.png";